import { render, staticRenderFns } from "./router-breadcrumb.vue?vue&type=template&id=373858b3"
import script from "./router-breadcrumb.vue?vue&type=script&lang=js"
export * from "./router-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./router-breadcrumb.vue?vue&type=style&index=0&id=373858b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports